

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import Home from './view/HelloFromVux'
import Scroller from 'vue-scroller'
import Promise from 'promise'
import $ from 'jquery'
import store from './store'
import fetch from './utils/fetch.js'
import setWechatTitle from './utils/setWechatTitle.js'

import Cube from 'cube-ui'

Vue.use(Cube)
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'


Vue.use(VueRouter)
Vue.use(Scroller)
Vue.use(WechatPlugin)
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(AjaxPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
var base_url = 'http://xxapi.yntulin.com/index.php'
Vue.prototype.base_url = base_url
Vue.prototype.base_api_url = 'http://xcxcgj.gotomore.cn/lizibookapi.php'
Vue.prototype.home_url = 'http://xcxcgj.gotomore.cn/index.html#/'
var that = this
Vue.prototype.xarpost = fetch
const routes = [{
path: '/',
component: function (resolve) {
require(['./view/tmap.vue'], resolve)
},
name: '门店',
},{
path: '/home/:openid/:redirectUrl',redirect: to => {
var params_openid = to.params.openid
var redirectUrl = to.params.redirectUrl
store.commit('updateOpenid', {openid: params_openid})
console.log(redirectUrl)
console.log(params_openid)

fetch('customer/syncLzUser', {openid: params_openid}).then((d) => {
let {data, error, message} = d
store.commit('updatetoken', data)
})
return decodeURIComponent(redirectUrl)
}
},{
path: '/my',
component: function (resolve) {
require(['./view/my.vue'], resolve)
},
name: '我的'
},{
path: '/message',
component: function (resolve) {
require(['./view/message.vue'], resolve)
},
name: '消息提醒'
},{
path: '/myvcard',
component: function (resolve) {
require(['./view/vcard/myvcard.vue'], resolve)
},
name: '我的洗车卡'
},{
path: '/tmap',
component: function (resolve) {
require(['./view/tmap.vue'], resolve)
},
name: '门店'
},{
path: '/vcard/:id',
component: function (resolve) {
require(['./view/goods/vcard.vue'], resolve)
},
name: '全城洗车卡'
},{
path: '/goods',
component: function (resolve) {
require(['./view/goods/goods.vue'], resolve)
},
name: '商品'
}
,{
path: '/comment/:pro_id/:shop_id/:order_id/:customer_id',
component: function (resolve) {
require(['./view/goods/comment.vue'], resolve)
},
name: '评价'
},
{
path: '/my_wash_card_list',
component: function (resolve) {
require(['./view/my/wash_card_list.vue'], resolve)
},
name: '我的卡包'
},
{
path: '/my_receive_address',
component: function (resolve) {
require(['./view/my/my_receive_address.vue'], resolve)
},
name: '我的收货地址'
},
{
path: '/my_receive_address_edit',
component: function (resolve) {
require(['./view/my/my_receive_address_edit.vue'], resolve)
},
name: '新增收货地址'
},
{
path: '/my_receive_address_edit/:add_id',
component: function (resolve) {
require(['./view/my/my_receive_address_edit.vue'], resolve)
},
name: '编辑收货地址'
},
{
path: '/cat_select',
component: function (resolve) {
require(['./view/shop/cat_select.vue'], resolve)
},
name: '卡片详情'
},
{
path: '/prolist',
component: function (resolve) {
require(['./view/shop/prolist.vue'], resolve)
},
name: '商品列表'
},
{
path: '/wash_card_detail/:id',
component: function (resolve) {
require(['./view/my/wash_card_detail.vue'], resolve)
},
name: '卡片详情'
},
{
path: '/order_detail/:id',
component: function (resolve) {
require(['./view/carorder/order_detail.vue'], resolve)
},
name: '接车单详情'
},
{
path: '/giveVcard/:card_code',
component: function (resolve) {
require(['./view/vcard/giveVcard.vue'], resolve)
},
name: '朋友赠送的洗车卡'
},
{
path: '/useRecord',
component: function (resolve) {
require(['./view/vcard/useRecord.vue'], resolve)
},
name: '使用记录'
},
{
path: '/buySuccess',
component: function (resolve) {
require(['./view/vcard/buySuccess.vue'], resolve)
},
name: '购买成功'
},
{
path: '/shopinfo',
component: function (resolve) {
require(['./view/shop/shopinfo.vue'], resolve)
},
name: '购买成功'
}
]
const router = new VueRouter({
routes
})
const history = window.sessionStorage
history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)
var is_request_wxinfo = 0
const wx = Vue.wechat
const url = document.location.href
const http = Vue.http
http.post(base_url+'?m=Lizibook&c=UsersWx&a=getjssdk&snsapi=snsapi_userinfo&url=' + encodeURIComponent(url.split('#')[0])).then(res => {
var config = {
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature: res.data.signature,
jsApiList: [
'checkJsApi',
'onMenuShareTimeline',
'onMenuShareAppMessage',
'onMenuShareQQ',
'onMenuShareWeibo',
'onMenuShareQZone',
'hideMenuItems',
'showMenuItems',
'hideAllNonBaseMenuItem',
'showAllNonBaseMenuItem',
'translateVoice',
'startRecord',
'stopRecord',
'onVoiceRecordEnd',
'playVoice',
'onVoicePlayEnd',
'pauseVoice',
'stopVoice',
'uploadVoice',
'downloadVoice',
'chooseImage',
'previewImage',
'uploadImage',
'downloadImage',
'getNetworkType',
'openLocation',
'getLocation',
'hideOptionMenu',
'showOptionMenu',
'closeWindow',
'scanQRCode',
'chooseWXPay',
'openProductSpecificView',
'addCard',
'chooseCard',
'openCard'
]
}
wx.config(config)
})
Vue.prototype.setWxShare = function (title='离你最近的汽车服务专家',desc='您的爱车，我们保养啦。',link='http://xcxcgj.gotomore.cn/index.html#/',imgUrl='http://xcxcgj.gotomore.cn/public/xarlogo.jpg') {
wx.ready(() => {
wx.onMenuShareTimeline({
title: '小矮人-'+title, // 分享标题
desc: desc,
link: link,
imgUrl: imgUrl
})
wx.onMenuShareAppMessage({
title: '小矮人-'+title, // 分享标题
desc: desc,
link: link,
imgUrl: imgUrl
})
})
}
router.beforeEach((to, from, next) => {
var openid = store.state.vux.openid
var userinfo = store.state.vux.userinfo
if(!openid){
var url_path = encodeURIComponent(to.fullPath)
location.href=base_url+'?m=Lizibook&c=UsersWx&a=wechat_middle_redic_xar&state='+url_path
return;
}



var showtabbarList = ['/','/my','/vcard','/tmap','/myvcard']
var showtabbar = false;
showtabbarList.map(function (item) {
if(item == to.path) showtabbar = true
})
store.commit('updateLoadingStatus', {isLoading: true})

store.commit('updateshowtabbar', {showtabbar: showtabbar})


if(!userinfo.openid){




}

const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)
if (toIndex) {
if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
store.commit('updateDirection', {direction: 'forward'})
} else {
store.commit('updateDirection', {direction: 'reverse'})
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
store.commit('updateDirection', {direction: 'forward'})
}
console.log(store.state, 'store')

Vue.prototype.setWxShare()
next()
})
if (process.env.NODE_ENV === 'development') {
store.commit('updateOpenid', {openid: 'oux15wmbP9OGLXxbQ7qgff1zm7Fg'})
fetch('customer/syncLzUser', {openid: 'oux15wmbP9OGLXxbQ7qgff1zm7Fg'}).then((d) => {
let {data, error, message} = d
store.commit('updatetoken', data)
})
store.commit('updateLocation', {
'latitude': 25.087526,
'longitude': 102.720859
})
}
Vue.prototype.getLocation = function(showLoading = true){
var self = this
return new Promise(function(resolve, reject){
var location = store.state.vux.location
if(location.latitude && location.longitude ){
resolve(location)
}else{
if(showLoading){
self.$vux.loading.show({
text: '定位中...'
})
}
wx.ready(() => {
wx.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
success: function (d) {
resolve(d)
},
cancel: function (res) {
showtoast('用户拒绝获取地理位置信息')
reject(res)
},
complete: function(res){
self.$vux.loading.hide()
}
});
})
}
})

}

Vue.prototype.setWechatTitle = setWechatTitle
router.afterEach((transition) => {
let title = '小矮人-'+transition.name
setWechatTitle(title)
store.commit('updateLoadingStatus', {isLoading: false})

})



Vue.prototype.get_user_info = function(cb,state=0){
var userinfo = store.state.vux.userinfo
if(state||!userinfo.openid){
if(!is_request_wxinfo){
is_request_wxinfo = 1

}
}else{
typeof cb == "function" && cb(userinfo)
Vue.prototype.userinfo = userinfo
}
}
function showtoast(msg = ''){
if(msg){
store.commit('updatetoastdata', {toastdata: {status: true, text: msg}})
}

}
Vue.prototype.showtoast = showtoast
Vue.prototype.xarpay = function (subject = '', body = '', product_id = 0, proinfo = '',  return_param = ''){
return new Promise(function(resfun, rejfun){
if(subject && body && proinfo && product_id){
var data = {}
data.openid   = store.state.vux.openid
console.log('kakakakak')
data.subject  = subject
data.body     = body
data.proinfo  = proinfo
data.pay_type = 'wx_pub'
var api_url   = 'http://xcxcgj.gotomore.cn/pay.php'
data.return_param = return_param
$.ajax({
type: 'POST',
url: api_url,
data: data,
})
.done(function(d){
if(d.error){
showtoast('支付参数错误，请联系管理员')
rejfun(d)
}else{
var pay = d.data
wx.chooseWXPay({
timestamp: pay.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
nonceStr: pay.nonceStr, // 支付签名随机串，不长于 32 位
package: pay.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
signType: pay.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
paySign: pay.paySign, // 支付签名
success: function (res) {
resfun(res)
},
cancel:function(res){
showtoast('取消支付')
rejfun(res)
},
fail:function(res){
showtoast('支付失败,请联系管理员')
rejfun(res)
}
});
}
}).fail(function(jqXHR, textStatus){
showtoast('网络错误')
rejfun(jqXHR)
})
}else{
showtoast('支付发起失败，请联系管理员')
rejfun(res)
}
})
}
$(document).ajaxStart(function(){
store.commit('updateLoadingStatus', {isLoading: true})
})
$(document).ajaxStop(function(){
store.commit('updateLoadingStatus', {isLoading: false})
})
FastClick.attach(document.body)
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')


// WEBPACK FOOTER //
// ./src/main.js